import { request } from '@umijs/max';

export interface DashboardStats {
  total_courses: number;
  total_employees: number;
  total_companies: number;
}

export interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

/**
 * Fetch dashboard statistics for admin
 * @returns Promise with dashboard statistics
 */
export const fetchDashboardStats = async (id: string, role: string): Promise<DashboardStats> => {
  try {

    // Call the real API endpoint
    const response = await request<DashboardStats>(`/api/dashboard/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (role === "admin") {
      return response[0];
    } else {
      return response

    }
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch dashboard statistics';
    // Return default values on error
    return {
      total_courses: 0,
      total_employees: 0,
      total_companies: 0,
    };
  }
};
